import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const PAGE_TITLES = {
  '/':          'Aether',
  '/news-feed': 'Aether',
  '/reels':     'Reels',
  '/salon':     'Salon',
  '/curation':  'Curation',
  '/search-results': 'Search',
  '/user-profile':   'Profile',
};

const MobileHeader = ({ onSearch }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useAuth();
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchVal, setSearchVal] = useState('');

  const isReels = pathname === '/reels';
  if (isReels) return null;

  const title = PAGE_TITLES[pathname] || 'Aether';
  const avatar = user?.user_metadata?.avatar_url;

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchVal.trim()) {
      navigate(`/search-results?q=${encodeURIComponent(searchVal.trim())}`);
      setSearchOpen(false);
      setSearchVal('');
    }
  };

  return (
    <header
      className="md:hidden fixed top-0 left-0 right-0 z-[80]"
      style={{
        background: 'rgba(9,9,11,0.85)',
        backdropFilter: 'blur(32px)',
        WebkitBackdropFilter: 'blur(32px)',
        borderBottom: '0.5px solid rgba(255,255,255,0.07)',
        paddingTop: 'env(safe-area-inset-top, 0px)',
        height: '56px',
      }}
    >
      <div className="flex items-center justify-between px-4 h-[56px]">
        {/* Left — Logo / Back */}
        {pathname === '/' || pathname === '/news-feed' ? (
          <span
            className="text-lg font-black tracking-[0.25em] uppercase"
            style={{ color: '#c9a96e', fontFamily: 'Plus Jakarta Sans, sans-serif' }}
          >
            AETHER
          </span>
        ) : (
          <button
            onClick={() => navigate(-1)}
            className="w-9 h-9 flex items-center justify-center rounded-full active:scale-90 transition-transform"
            style={{ background: 'rgba(255,255,255,0.06)' }}
          >
            <span className="material-symbols-outlined text-white text-[20px]">arrow_back</span>
          </button>
        )}

        {/* Center — Page title (non-home pages) */}
        {pathname !== '/' && pathname !== '/news-feed' && (
          <span className="text-white font-bold text-base tracking-wide">{title}</span>
        )}

        {/* Right — Search + Avatar */}
        <div className="flex items-center gap-2">
          {/* Search toggle */}
          <button
            onClick={() => setSearchOpen((v) => !v)}
            className="w-9 h-9 flex items-center justify-center rounded-full active:scale-90 transition-all"
            style={{ background: 'rgba(255,255,255,0.06)' }}
          >
            <span className="material-symbols-outlined text-white/70 text-[20px]">
              {searchOpen ? 'close' : 'search'}
            </span>
          </button>

          {/* Notifications */}
          <button
            className="w-9 h-9 flex items-center justify-center rounded-full active:scale-90 transition-all relative"
            style={{ background: 'rgba(255,255,255,0.06)' }}
          >
            <span className="material-symbols-outlined text-white/70 text-[20px]">notifications</span>
            {/* Unread dot */}
            <span
              className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full border border-background"
              style={{ background: '#c9a96e' }}
            />
          </button>

          {/* Avatar */}
          <button
            onClick={() => navigate('/curation')}
            className="w-8 h-8 rounded-full overflow-hidden active:scale-90 transition-transform"
            style={{ border: '1.5px solid rgba(201,169,110,0.5)' }}
          >
            {avatar ? (
              <img src={avatar} alt="You" className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex items-center justify-center" style={{ background: 'rgba(201,169,110,0.2)' }}>
                <span className="material-symbols-outlined text-[#c9a96e] text-[16px]">person</span>
              </div>
            )}
          </button>
        </div>
      </div>

      {/* Inline search bar — slides down */}
      {searchOpen && (
        <div
          className="px-4 pb-3"
          style={{ background: 'rgba(9,9,11,0.95)', borderBottom: '0.5px solid rgba(255,255,255,0.06)' }}
        >
          <form onSubmit={handleSearchSubmit} className="relative">
            <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-white/30 text-[18px]">search</span>
            <input
              autoFocus
              type="text"
              value={searchVal}
              onChange={(e) => setSearchVal(e.target.value)}
              placeholder="Search people, posts, topics…"
              className="w-full pl-10 pr-4 py-2.5 rounded-full text-sm text-white placeholder-white/30 outline-none"
              style={{
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.1)',
              }}
            />
          </form>
        </div>
      )}
    </header>
  );
};

export default MobileHeader;
